import {MatchEvent} from '../resources/MatchEvent';
import {DomainEvent} from './DomainEvent';

export class MatchEventWhistlePenaltyShootoutStop extends DomainEvent<MatchEvent> {}
